import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { TWizardStepId } from '../../../interfaces';
import { AppSettings } from '../../../models/app-settings.model';
import { AppSettingsService } from '../../../services';
import { WizardStepBaseComponent } from '../base/wizard-step-base.component';

@Component({
    selector: 'app-wizard-step-done',
    templateUrl: './wizard-step-done.component.html',
    styleUrls: ['../base/wizard-step-base.component.scss', './wizard-step-done.component.scss'],
    imports: [TranslatePipe],
})
export class WizardStepDoneComponent extends WizardStepBaseComponent {
    public id: TWizardStepId = 'done';
    public nextButtonLabel = 'toPortal';
    public url: AppSettings['url'];

    public constructor() {
        const appSettings = inject(AppSettingsService);

        super();

        appSettings
            .get(
                tap((settings) => {
                    this.url = settings.url;
                    this.nextPageLink = this.url.portal;
                })
            )
            .subscribe();
    }

    protected submitWizardStep(): Observable<boolean> {
        return of(false);
    }
}
